import CloseBtn from "../CloseBtn/CloseBtn";
import s from "./Contacts.module.css";
import { useTranslation } from "react-i18next";

const Contacts = () => {
	const { t } = useTranslation();
	return (
			<div className={s.scrollBlock}>
				<div className={s.modal}>
					<h3 className={s.title}>{t("NavBar.contacts")}</h3>
					<div className={s.block}>
						{t("ContactsOfUs.content")}
					</div>
					<CloseBtn />
				</div>
			</div>
	);
};

export default Contacts;
